export default __webpack_public_path__ + "static/media/whiteLogo.658ccc75.png";